import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";

export default function PieChart(props) {
  const {
    header,
    doughnutHoleSize,
    classParams,
    data,
    colors = ["#e5deed", "#5b2f91"]
  } = props;

  const chartRef = useRef(null);

  const drawPieSlice = (
    ctx,
    centerX,
    centerY,
    radius,
    startAngle,
    endAngle,
    color
  ) => {
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.moveTo(centerX, centerY);
    ctx.arc(centerX, centerY, radius, startAngle, endAngle);
    ctx.closePath();
    ctx.fill();
  };

  const draw = (ctx, canvas) => {
    const totalValue = 100;
    const options = typeof data !== "object" ? [data, 100 - data] : [...data];
    let color_index = 0;
    let startAngle = 3.1415926536;

    options.forEach(n => {
      const slice_angle = (2 * Math.PI * n) / totalValue / 2;

      drawPieSlice(
        ctx,
        canvas.width / 2 - 30,
        canvas.height,
        120,
        startAngle,
        startAngle + slice_angle,
        colors[color_index % colors.length]
      );

      startAngle += slice_angle;
      color_index++;
    });

    if (doughnutHoleSize) {
      drawPieSlice(
        ctx,
        canvas.width / 2 - 30,
        canvas.height,
        doughnutHoleSize * 120,
        0,
        2 * Math.PI,
        "#ffffff"
      );
    }
  };

  useEffect(() => {
    const canvas = chartRef.current;
    const context = canvas.getContext("2d");

    draw(context, canvas);
  }, [draw]);

  return (
    /* eslint-disable jsx-a11y/label-has-associated-control */
    <>
      {header ? (
        <label className='pie-chart-header-web-sdk'>{header}</label>
      ) : null}
      <canvas
        ref={chartRef}
        className={`pie-chart-web-sdk${classParams ? ` ${classParams}` : ""}`}
      />
      <label className='pie-chart-percentage-web-sdk'>{data}%</label>
    </>
  );
}

PieChart.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number)
  ]).isRequired,
  header: PropTypes.string,
  doughnutHoleSize: PropTypes.number,
  classParams: PropTypes.string,
  colors: PropTypes.arrayOf(PropTypes.string)
};
